import { defineComponent, computed } from "vue";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import AudioSettingTab from "../common/AudioSettingTab.vue.mjs";
import VideoSettingTab from "../common/VideoSettingTab.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { storeToRefs } from "pinia";
import { SettingMode } from "../../constants/render.mjs";
import { useI18n } from "../../locales/index.mjs";
import CloseIcon from "../common/icons/CloseIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  setup(__props) {
    const { t } = useI18n();
    const basicStore = useBasicStore();
    const { showSettingDialog, activeSettingTab } = storeToRefs(basicStore);
    const settingTabsTitleList = computed(() => [
      { label: t("Audio settings"), value: "audio" },
      { label: t("Camera settings"), value: "video" }
    ]);
    function handleUpdateActiveTab(tabTitle) {
      basicStore.setActiveSettingTab(tabTitle);
    }
    function handleCloseSettingDialog() {
      basicStore.setShowSettingDialog(false);
    }
    function handleOverlayClick(event) {
      if (event.target !== event.currentTarget) {
        return;
      }
      handleCloseSettingDialog();
    }
    return { __sfc: true, t, basicStore, showSettingDialog, activeSettingTab, settingTabsTitleList, handleUpdateActiveTab, handleCloseSettingDialog, handleOverlayClick, SvgIcon, AudioSettingTab, VideoSettingTab, SettingMode, CloseIcon };
  }
});
export {
  _sfc_main as default
};
